import PaymentHistoryHeader from "../../../components/PaymentHistoryHeader"
import WithSidebar from "../../../layouts/WithSidebar"
import PaymentList from "../../../components/Payment-list"
import { useEffect, useState, useRef } from "react"
import { ajax } from "../../../scripts/helper"
import utils from "../../../scripts/utils"
import { useSnackbar } from 'notistack'
import "./history.css";
import "../../../fonts/font.css"
import context from '../../../scripts/context'
import List from "../../../components/List"
import { useSearchParams } from "react-router-dom"
import PaymentHistoryModal from "../../../components/Modals/Payment-history-modal"


const History = () => {
    const { enqueueSnackbar } = useSnackbar()
    const paymentHistoryModalRef = useRef()
    const [searchParams, setSearchParams] = useSearchParams()
    const transactionId = searchParams.get('id')
    const columns = [
      {name: 'ID'},
      {name: 'User'},
      {name: 'Date'},
      {name: 'summary'},
      {name: 'Actions'},
  ]
    const [paymentHistories, setPaymentHistories] = useState([])
    const [totalCounts, setTotalCounts] = useState(-1);
    const [page, setPage] = useState(0)
    const [historyDetail, setHistoryDetail] = useState({})
    // const [params, setParams] = useState(makeParams(paymentInputFilter))

    const getPaymentHistoryLinks = async (page, rowsPerPage=10) => {
        const res = await ajax({
            method: 'GET',
            url: `${utils.urls.transactionHistory(transactionId)}?size=${rowsPerPage}&page=${page}`,
            snackbar: enqueueSnackbar,
            hasToken: true
        })
        if(!res) return 
        setPaymentHistories(res.data.content)
        setTotalCounts(res.data.totalElements)
    }
    const actions = {

      onShowHistoryDetail:(history)=>{
        if (history.details) {
          setHistoryDetail(JSON.parse(history.details))
          paymentHistoryModalRef.current.openModal()
        }
      }
    }

    const onPageChange = (page, rowsPerPage) => {
        setPage(page)
        getPaymentHistoryLinks(page, rowsPerPage)
    }

    // useEffect( () => {
    //     getPaymentLinks(page)
    // }, [])

    useEffect( () => {
        getPaymentHistoryLinks(page)
    }, [])

    return (
        <WithSidebar pageTitle={"Payment history"} breadcrumb={"Dashboard > Payment > History"} listHeaders={<PaymentHistoryHeader transactionId={transactionId} />}>
            <List columns={columns} rows={paymentHistories} type={'paymentsHistory'} totalCounts={totalCounts} page={page} onPageChange={onPageChange} actions={actions}/>
            <PaymentHistoryModal data={historyDetail} ref={paymentHistoryModalRef}></PaymentHistoryModal>
        </WithSidebar>
    )
}
export default History